export class LoaderProperties {
    isOpaque?: boolean;
    isFull?: boolean;
    isPositionStatic?: boolean;
    loaderText?: string;
    height?: string;
    width?: string;
    fontSize?: string;
    containerHeight?: string;

    constructor() {
        this.isOpaque = false;
        this.isFull = false;
        this.isPositionStatic = false;
        this.loaderText = "Loading...";
        this.height = "75%";
        this.width = "75%";
        this.fontSize = "16px";
    }
}